// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../../types/schema';

import { GiftingProposalProjectionFragment } from '../../../graphql/GiftingProposalProjection.fragment.generated';
import { gql } from '@apollo/client';
import { GiftingProposalProjectionFragmentDoc } from '../../../graphql/GiftingProposalProjection.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetGiftDesignerModelScenariosFormData_GiftingProposalCashFlowFragment = { __typename?: 'GiftingProposalCashFlow', id: string, displayName: string, growthPercentage?: Percent | null, amount: CurrencyUSD, annuallyRecurring?: boolean | null, endYear?: number | null, startYear: number, cashFlowType: Types.GiftingProposalCashFlowCashFlowType, order: number, portfolio?: { __typename?: 'GiftingProposalPortfolio', id: string } | null };

export type GetGiftDesignerModelScenariosFormData_GiftingScenariosFragment = { __typename?: 'GiftingProposalScenario', id: string, displayName: string, isDefault: boolean, order: number, isBaseline: boolean, projections: (
    { __typename?: 'GiftingProposalProjections' }
    & GiftingProposalProjectionFragment
  ), scenarioGifts?: Array<{ __typename?: 'GiftingProposalGift', id: string, displayName: string, growthPercentage?: Percent | null, nonTaxableGiftType?: Types.GiftingProposalGiftNonTaxableGiftType | null, amount: CurrencyUSD, annuallyRecurring?: boolean | null, endYear?: number | null, startYear: number, isTaxable: boolean, recipientKind?: Types.GiftingProposalGiftRecipientKind | null, discount?: boolean | null, discountPercentage?: Percent | null, order: number, recipientPortfolio?: { __typename?: 'GiftingProposalPortfolio', id: string } | null, recipientClientProfile?: { __typename?: 'ClientProfile', id: string } | null, recipientClientOrganization?: { __typename?: 'ClientOrganization', id: string } | null, senders?: Array<{ __typename?: 'GiftingProposalGiftSender', id: string, grantor: { __typename?: 'ClientProfile', id: string } }> | null }> | null, scenarioCashFlows?: Array<(
    { __typename?: 'GiftingProposalCashFlow' }
    & GetGiftDesignerModelScenariosFormData_GiftingProposalCashFlowFragment
  )> | null };

export type GetGiftDesignerModelScenariosFormData_ProposalFragment = { __typename?: 'Proposal', id: string, displayName: string, giftingProposal?: { __typename?: 'GiftingProposal', id: string, status: Types.GiftingProposalStatus, lengthOfAnalysis: number, inEstatePortfolioValue: CurrencyUSD, selectedYearOfAnalysis?: number | null, preTaxReturnPercentageLow?: Percent | null, preTaxReturnPercentageMedium?: Percent | null, preTaxReturnPercentageHigh?: Percent | null, taxDragPercentageLow?: Percent | null, taxDragPercentageMedium?: Percent | null, taxDragPercentageHigh?: Percent | null, exemptionGrowthRate?: Percent | null, showAfterEstateTax?: boolean | null, selectedPreTaxReturnCategory?: Types.GiftingProposalSelectedPreTaxReturnCategory | null, baseCashFlows?: Array<(
      { __typename?: 'GiftingProposalCashFlow' }
      & GetGiftDesignerModelScenariosFormData_GiftingProposalCashFlowFragment
    )> | null, giftingScenarios?: Array<(
      { __typename?: 'GiftingProposalScenario' }
      & GetGiftDesignerModelScenariosFormData_GiftingScenariosFragment
    )> | null } | null };

export type GetGiftDesignerModelScenariosFormDataQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProposalWhereInput>;
}>;


export type GetGiftDesignerModelScenariosFormDataQuery = { __typename?: 'Query', proposals: { __typename?: 'ProposalConnection', edges?: Array<{ __typename?: 'ProposalEdge', node?: (
        { __typename?: 'Proposal', id: string }
        & GetGiftDesignerModelScenariosFormData_ProposalFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    GetGiftDesignerModelScenariosFormData: 'GetGiftDesignerModelScenariosFormData' as const
  },
  Fragment: {
    GetGiftDesignerModelScenariosFormData_GiftingProposalCashFlow: 'GetGiftDesignerModelScenariosFormData_GiftingProposalCashFlow' as const,
    GetGiftDesignerModelScenariosFormData_GiftingScenarios: 'GetGiftDesignerModelScenariosFormData_GiftingScenarios' as const,
    GetGiftDesignerModelScenariosFormData_Proposal: 'GetGiftDesignerModelScenariosFormData_Proposal' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const GetGiftDesignerModelScenariosFormData_GiftingProposalCashFlowFragmentDoc = gql`
    fragment GetGiftDesignerModelScenariosFormData_GiftingProposalCashFlow on GiftingProposalCashFlow {
  id
  displayName
  growthPercentage
  amount
  annuallyRecurring
  endYear
  startYear
  cashFlowType
  order
  portfolio {
    id
  }
}
    `;
export const GetGiftDesignerModelScenariosFormData_GiftingScenariosFragmentDoc = gql`
    fragment GetGiftDesignerModelScenariosFormData_GiftingScenarios on GiftingProposalScenario {
  id
  displayName
  isDefault
  order
  projections {
    ...GiftingProposalProjection
  }
  isBaseline @client
  scenarioGifts {
    id
    displayName
    growthPercentage
    nonTaxableGiftType
    amount
    annuallyRecurring
    endYear
    startYear
    isTaxable
    recipientPortfolio {
      id
    }
    recipientClientProfile {
      id
    }
    recipientClientOrganization {
      id
    }
    recipientKind
    senders {
      id
      grantor {
        id
      }
    }
    discount
    discountPercentage
    order
  }
  scenarioCashFlows {
    ...GetGiftDesignerModelScenariosFormData_GiftingProposalCashFlow
  }
}
    ${GiftingProposalProjectionFragmentDoc}
${GetGiftDesignerModelScenariosFormData_GiftingProposalCashFlowFragmentDoc}`;
export const GetGiftDesignerModelScenariosFormData_ProposalFragmentDoc = gql`
    fragment GetGiftDesignerModelScenariosFormData_Proposal on Proposal {
  id
  displayName
  giftingProposal {
    id
    status
    lengthOfAnalysis
    inEstatePortfolioValue
    selectedYearOfAnalysis
    preTaxReturnPercentageLow
    preTaxReturnPercentageMedium
    preTaxReturnPercentageHigh
    taxDragPercentageLow
    taxDragPercentageMedium
    taxDragPercentageHigh
    exemptionGrowthRate
    showAfterEstateTax
    selectedPreTaxReturnCategory
    baseCashFlows {
      ...GetGiftDesignerModelScenariosFormData_GiftingProposalCashFlow
    }
    giftingScenarios {
      ...GetGiftDesignerModelScenariosFormData_GiftingScenarios
    }
  }
}
    ${GetGiftDesignerModelScenariosFormData_GiftingProposalCashFlowFragmentDoc}
${GetGiftDesignerModelScenariosFormData_GiftingScenariosFragmentDoc}`;
export const GetGiftDesignerModelScenariosFormDataDocument = gql`
    query GetGiftDesignerModelScenariosFormData($where: ProposalWhereInput) {
  proposals(where: $where) {
    edges {
      node {
        id
        ...GetGiftDesignerModelScenariosFormData_Proposal
      }
    }
  }
}
    ${GetGiftDesignerModelScenariosFormData_ProposalFragmentDoc}`;

/**
 * __useGetGiftDesignerModelScenariosFormDataQuery__
 *
 * To run a query within a React component, call `useGetGiftDesignerModelScenariosFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGiftDesignerModelScenariosFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGiftDesignerModelScenariosFormDataQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetGiftDesignerModelScenariosFormDataQuery(baseOptions?: Apollo.QueryHookOptions<GetGiftDesignerModelScenariosFormDataQuery, GetGiftDesignerModelScenariosFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGiftDesignerModelScenariosFormDataQuery, GetGiftDesignerModelScenariosFormDataQueryVariables>(GetGiftDesignerModelScenariosFormDataDocument, withFetchPolicyContext(options));
      }
export function useGetGiftDesignerModelScenariosFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGiftDesignerModelScenariosFormDataQuery, GetGiftDesignerModelScenariosFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGiftDesignerModelScenariosFormDataQuery, GetGiftDesignerModelScenariosFormDataQueryVariables>(GetGiftDesignerModelScenariosFormDataDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetGiftDesignerModelScenariosFormDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGiftDesignerModelScenariosFormDataQuery, GetGiftDesignerModelScenariosFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGiftDesignerModelScenariosFormDataQuery, GetGiftDesignerModelScenariosFormDataQueryVariables>(GetGiftDesignerModelScenariosFormDataDocument, withFetchPolicyContext(options));
        }
export type GetGiftDesignerModelScenariosFormDataQueryHookResult = ReturnType<typeof useGetGiftDesignerModelScenariosFormDataQuery>;
export type GetGiftDesignerModelScenariosFormDataLazyQueryHookResult = ReturnType<typeof useGetGiftDesignerModelScenariosFormDataLazyQuery>;
export type GetGiftDesignerModelScenariosFormDataSuspenseQueryHookResult = ReturnType<typeof useGetGiftDesignerModelScenariosFormDataSuspenseQuery>;
export type GetGiftDesignerModelScenariosFormDataQueryResult = Apollo.QueryResult<GetGiftDesignerModelScenariosFormDataQuery, GetGiftDesignerModelScenariosFormDataQueryVariables>;